// A contract's figures flagged to review (finance-real round 7) read on amber wherever its price or margin shows: its row on
// the client page and its drawer. Hovering names the note.
import type { ReactNode } from "react";
import type { PriceReview } from "../types";
import { dateLabel } from "../utils/format";

export const reviewText = (review: PriceReview): string => `To review since ${dateLabel(review.since)}${review.note ? `: ${review.note}` : ""}`;

export function ReviewMark({ review, children }: { review: PriceReview | null; children: ReactNode }) {
  if (!review) return <>{children}</>;
  return (
    <span className="whitespace-nowrap rounded bg-amber-100 px-1.5 py-0.5 ring-1 ring-inset ring-amber-300" title={reviewText(review)}>
      {children}
    </span>
  );
}
